import React, { Fragment } from 'react';

import { MemberExternalId } from '@vestahealthcare/common/models';

import { DetailItem } from '../utils';

type Props = {
  externalIds?: MemberExternalId[];
};

export const MemberExternalIdsDetail = ({ externalIds }: Props) => {
  return externalIds?.length ? (
    <>
      {externalIds.map((externalId: MemberExternalId) => (
        <DetailItem
          avoidTranslation
          key={externalId.id}
          label={externalId.externalIdSource.name}
        >
          {externalId.externalId}
        </DetailItem>
      ))}
    </>
  ) : (
    <DetailItem namespace="personalDetailsCard" label="emr" />
  );
};
